import React from 'react';

const RichTextElement = ({ element }) => {
  const { content } = element;
  const { html = '', alignment = 'left', fontSize = 'normal' } = content || {};

  const style = {
    textAlign: alignment,
    fontSize: fontSize === 'small' ? '0.875rem' : fontSize === 'large' ? '1.125rem' : '1rem',
    lineHeight: '1.6',
    color: 'var(--color-text)'
  };

  return (
    <div 
      className="builder-richtext" 
      style={style}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};

export default RichTextElement;
